import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { DefensivoFormValue, TratamentoFormValue } from '../../../../@types';
import defaultColumnProps from '../../../../utils/default-column-props';
import {
  calculaQuantidadeInsumo,
  getPesoComPms,
  isSegundoTratamento,
} from '../utils';

const TratamentoDeSementesResumoRowExpansion = (
  tratamento: TratamentoFormValue,
) => {
  const { defensivos, quantidade, unidade: unidadeTs, pms } = tratamento;
  const segundoTratamento =
    isSegundoTratamento(tratamento) || !tratamento.unidade;

  return (
    <DataTable
      dataKey="item.id"
      value={defensivos}
      className="w-6 table-row-expansion"
      emptyMessage="Nenhum defensivo foi escolhido para esse tratamento"
    >
      <Column
        {...defaultColumnProps('left', false)}
        header="Insumo"
        field="item.descricao"
      />
      <Column
        {...defaultColumnProps('right', false)}
        header={segundoTratamento ? 'Quantidade' : 'Dose'}
        body={(data: DefensivoFormValue) => {
          const formattedValue = formatNumber(
            (segundoTratamento ? data.quantidade : data.dose) || 0,
            {
              maximumFractionDigits: 4,
            },
          );
          const unidade = data.item?.unidade.abreviatura || '';
          return `${formattedValue} ${unidade}${
            segundoTratamento ? '' : '/100kg'
          }`;
        }}
      />
      <Column
        {...defaultColumnProps('right', false)}
        header="Total"
        body={(data: DefensivoFormValue) => {
          const pesoComPms = getPesoComPms({
            unidade: unidadeTs,
            quantidade,
            pms,
          });

          const total = segundoTratamento
            ? data.quantidade || 0
            : calculaQuantidadeInsumo({
                dose: data.dose || 0,
                peso: pesoComPms,
              });
          const formattedTotal = formatNumber(total, {
            maximumFractionDigits: 4,
          });

          const unidade = data.item?.unidade.abreviatura || '';

          return `${formattedTotal} ${unidade}`;
        }}
      />
    </DataTable>
  );
};

export default TratamentoDeSementesResumoRowExpansion;
